import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import $ from 'jquery';

@Component({})
export default class BaseComponent extends Vue {

  @Mutation('setAccessToken', StoreNamespace.AUTHORIZATION)
  protected setAccessToken: any;

  @Mutation('setRefreshToken', StoreNamespace.AUTHORIZATION)
  protected setRefreshToken: any;

  @Getter('refreshToken', StoreNamespace.AUTHORIZATION)
  protected refreshToken: any;

  protected loading: boolean = false;
  protected hasFeedback: boolean = false;
  protected serverErrorMessages: string[] = [];

  public mounted() {
    $('body').addClass('jQuery');
  }

  @Watch('$route')
  public onRouteChanged(newVal: any, oldVal: any) {
    this.serverErrorMessages = [];
  }

  public cleanServerErrorMessages(): any {
    this.serverErrorMessages = [];
  }

}
